import { useState } from "react";
import { Card, Button, ButtonGroup } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

export const UmleitungenPager = ({ images, imgId, onClose }) => {
    const location = useLocation();
    const navigate = useNavigate();
    // const images = location.state?.images || [];
    // const imgId = location.state?.imgId || 0;
    const [currentIndex, setCurrentIndex] = useState(imgId);

    if (!images || images.length === 0) return null;

    const handlePrev = () => setCurrentIndex(i => (i > 0 ? i - 1 : images.length - 1));
    const handleNext = () => setCurrentIndex(i => (i < images.length - 1 ? i + 1 : 0));

    return (
        <div style={{ textAlign: "center", marginTop: 16 }}>
            <Card sx={{ m: 1, p: 1, display: "inline-block" }}>
                <img
                    src={images[currentIndex]}
                    alt={`Umleitung ${currentIndex + 1}`}
                    style={{ width: "100%", height: "auto", maxWidth: 400 }}
                />
                <div style={{ marginTop: 8 }}>
                    <ButtonGroup size="small" variant="outlined">
                        <Button onClick={handlePrev}>Zurück</Button>
                        <Button disabled>
                            {currentIndex + 1} / {images.length}
                        </Button>
                        <Button onClick={handleNext}>Weiter</Button>
                    </ButtonGroup>
                </div>
                {/* <Button onClick={() => navigate(-1)} style={{ marginTop: 8 }}>Schließen</Button> */}
                <Button onClick={onClose} style={{ marginTop: 8 }}>
                    Schließen
                </Button>
            </Card>
        </div>
    );
};
export default UmleitungenPager;